<template>
  <div
    :class="
      $route.path.includes('products') ? 'products-listing__wrapper2' : 'products-listing__wrapper'
    "
    style="width: 18%; display: flex; flex-direction: column; align-items: flex-start"
    :style="
      $route.path.includes('products')
        ? 'margin-top: 6px; width: 25%; display: flex; flex-direction: column; align-items: flex-start;'
        : 'margin-top: 6px; width: 25%; display: flex; flex-direction: column; align-items: flex-start;'
    "
  >
    <button
      v-if="$route.path.includes('products')"
      v-b-modal.modal-add-size
      class="button"
      style="border-radius: 6px"
      :disabled="!colorId"
      :class="{'button--disabled': (!colorId && getDressesSize.length == 0)}"
      @click="getMaterialVByMandP"
    >
      <b-icon-plus />
      {{ $t('AddBarcode') }}
    </button>
    <div
      class="table__header"
      style="margin-bottom: 15px !important; margin-top: 0px"
    >
      <button
        v-if="$route.path.includes('create-order') "
        v-b-modal.add-custom-order
        class="button"
        style="border-radius: 6px; width: auto; position: relative; width: 198px; "
        @click="rr"
      >
        <img
          src="../../assets/images/plus-circle.svg"
          alt="plus"
        >
        {{ $t('AddOrder') }}
        <span
          v-if="counter != 0"
          style="font-size: 13px; background: red; border-radius: 50%; width: 20px; height: 20px; position: absolute; top: -5px; right: -9px; "
        >{{ counter == 0 ? '' : counter }}</span>
      </button>
    </div>
    <div
      style="width: 100%;  padding-top: 16px"
      :class="{'button--disabled': getDressesSize.length == 0}"
      :style="$route.path.includes('products') ? 'margin-top:-3px;' : 'margin-top: -17px'"
    >
      <table
        class="team_table"
      >
        <thead style="border-bottom: 1px solid #dcdfe6; color: #606266; text-align: left">
          <tr>
            <th>
              {{ $t('ArticleName') }}
            </th>
            <th>
              {{ $t('Size') }}
            </th>
            <th>
              {{ $t('Price') }}
            </th>
            <th
              v-if="$route.path.includes('products') && client=='FjollaNila'"
            >
              {{ $t('Stock') }}
            </th>
            <th
              v-if="$route.path.includes('products') && client !='FjollaNila'"
              colspan="2"
            >
              {{ $t('Edit') }}
            </th>
            <th
              v-if="$route.path.includes('create-order')"
            />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in getDressesSize"
            :key="item.inventoryProductId"
            class="hover-row"
            style="border-bottom: 1px solid #dcdfe6; color: #606266; cursor: pointer"
            :style="classNameCh === item.inventoryProductId ? 'background-color: rgba(255, 39, 79, 0.1)' : ''"
            @click="matProps(item)"
          >
            <td>
              {{ item.articleNumber }}
            </td>
            <td>
              {{ item.size }}
            </td>
            <td style="width: 17%;">
              {{ numbersWithcomma(item.price) }} {{ item.currency }}
            </td>
            <td
              v-if="$route.path.includes('products') && client=='FjollaNila'"
              :style="
                $route.path.includes('products')
                  ? 'padding: 10px; text-align: left; cursor: pointer; color:#141414 !important ; font-weight: 400;'
                  : 'padding: 5px; color:#141414 !important ; font-weight: 400;'
              "
              @click="showModal"
            >
              <b-button
                v-b-modal.add-direct-instock
                class="small"
                size="sm"
                @click="AddToCustom(item), edit(item)"
              >
                <span v-if="item.added">{{ $t('Added') }}</span>
                <span v-else> {{ $t('AddToStock') }}</span>
              </b-button>
            </td>
            <td
              v-if="$route.path.includes('products')"
              v-b-modal.modal-edit-size
              :style="
                $route.path.includes('products')
                  ? 'padding: 10px; text-align: left; cursor: pointer; color:#141414 !important ; font-weight: 400;'
                  : 'padding: 3px; color:#141414 !important ; font-weight: 400;'
              "
              @click="edit(item)"
            >
              <b-icon-pencil />
            </td>
            <td
              v-if="$route.path.includes('create-order')"
              :style="
                $route.path.includes('products')
                  ? 'padding: 10px; text-align: left; cursor: pointer'
                  : 'padding: 5px'
              "
            >
              <b-button
                class="small"
                size="sm"
                style="border: none;width:150px;height: 30px;"
                @click="AddToCustom(item)"
              >
                <span v-if="item.added">{{ $t('Added') }}</span>
                <span v-else> {{ $t('AddToS') }}</span>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <AddSize
      :materials="materialId"
      :measure-item="measureId"
      :color-data="colorId"
      @variantMaterialData="variantMaterialData"
    /> -->
    <!-- <AddDirectInStock
      :color-data="colorId"
      :materials="materialId"
      :measure-item="measureId"
      :e-size="eSize"
      @AddDirectInStock="createOrderInStoreTemporary"
    /> -->
    <!-- <EditSize
      :color-data="colorId"
      :materials="materialId"
      :measure-item="measureId"
      :e-size="eSize"
      :pricess="prices"
      :materials-article-num="getMaterialsByArticleNum.productSingleMaterialVariantDtos"
      @updateSize="editSize"
    /> -->
    <CreateOrderModal
      ref="childComponentRef"
      :added-article="rows"
      :materials="getMaterialsByArticleNum"
      @createOrder="createOrderInStore"
      @incrementCounter="increment"
      @decrementCounter="decrement"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CreateOrderModal from '@/modals/CreateOrderModal.vue';
// import AddSize from '@/components/products/modals/AddSize.vue';
// import AddDirectInStock from '@/components/products/modals/AddDirectInStock.vue';
// import EditSize from '@/components/products/modals/EditSize.vue';
import { client } from '../../domainConfig';

export default {
  components: {
    // AddSize,
    // AddDirectInStock,
    CreateOrderModal,
    // EditSize,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    materialId: {
      type: [String, Object],
    },
    createOrder: {
      type: Boolean,
    },
    // eslint-disable-next-line vue/require-default-prop
    colorId: {
      type: [String, Object],
    },
    measureId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      initialId: '',
      materialPropId: '',
      modalVisible: false,
      client: client.clientName,
      status: true,
      size: '',
      prices: {
        price: 0,
        currency: '',
      },
      eSize: {
        size: '',
      },
      classNameCh: '',
      searchTerm: '',
      rows: [],
      materialObject: {},
      editMat: {},
      artNum: '',
      invProdId: '',
      counter: 0,
    };
  },
  computed: {
    ...mapGetters([
      'getDressesSize',
      'getCustomOrders',
      'getMaterialsByArticleNum',
      'getResetStatus',
      'getDressColors',
      'getMeasermentsById',
    ]),
  },
  watch: {
    getResetStatus(value) {
      if (value == true) { this.rows = []; this.counter = 0; this.resetCustomOrders2() }
    },
  },
  mounted() {
    // console.log('22', this.getMeasermentsById)
  },
  methods: {
    ...mapActions([
      'productSizes',
      'inventoryProductSizeFromColorId',
      'getInventoryProductsByColorId',
      'productsByArticleNumber',
      'addInventoryProductSize',
      'editInventoryProductSize',
      'addOrderInStore',
      'resetCustomOrders',
      'resetCustomOrders2',
      'getMaterialVariantsToMDCPagination',
      'resetDressColors',
      'resetSizes',
      'resetProductsByArticleNumber',
      'loadMeasermentsById',
      'addProductInStock',
      'addProductDirectInStock',
      'loadAllStoresByDropdown',
      'accountDetails',
    ]),
    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    showModal() {
      this.modalVisible = true;
    },
    edit(item) {
      this.prices.price = item.price
      this.prices.currency = item.currency
      this.eSize.size = item.size;
      this.invProdId = item.inventoryProductId;
      this.getMaterialVByMandP()
    },
    async editSize(obj) {
      await this.editInventoryProductSize({
        inventoryProductId: this.invProdId,
        object: obj,
        successCallback: () => {
          this.inventoryProductSizeFromColorId(this.colorId.mainDressCategoryColorId);
          this.productsByArticleNumber(this.artNum);
        },
      });
    },
    rr() {
      // this.loadOrderTypes()
      this.getMaterialVByMandP()
      if (this.getResetStatus == true) {
        this.rows = [];
      }
      this.accountDetails({ isActive: true })
      this.productSizes()
      this.loadAllStoresByDropdown({
        amountOfRecords: 100,
      })
    },
    increment() {
      this.counter++;
    },
    decrement() {
      this.counter--;
    },
    async AddToCustom(item) {
      await this.productsByArticleNumber(item.articleNumber);
      const t = {
        twentyPrinciples: null,
        bodyMeasurements: {},
        itemi: item,
        pickUpDate: '',
        filledPickUpDate: true,
        showLengthError: false,
        showDressError: false,
        materials: this.getMaterialsByArticleNum,
        probeDates: [],
        paidPrice: 0,
        price: 0,
      }
      console.log(t)
      this.rows.push(t);
      this.counter++;
      this.resetCustomOrders2();
    },
    async createOrderInStore(obj) {
      await this.addOrderInStore({
        object: obj,
        successCallback: () => {
          // This function will be called on success
          this.$refs.childComponentRef.resetForm();
        },
      });
      this.resetDressColors()
      this.resetSizes()
      this.resetProductsByArticleNumber()
    },
    async createOrderInStoreTemporary() {
      await this.productsByArticleNumber(this.artNum);
      const object2 = []
      object2.push({
        bodyMeasurements: null,
        articleNumber: this.artNum,
        materialVariantDtos: this.getMaterialsByArticleNum,
      })
      const t = {
        articleNumber: this.artNum, productInStockMaterialVariantRequestDtos: object2, message: '', size: this.size,
      }
      this.rows.push(t);
      await this.addProductDirectInStock(t);
      this.resetProductsByArticleNumber()
      this.classNameCh = '';
    },
    async variantMaterialData(filterObj) {
      // eslint-disable-next-line no-unused-vars
      const addInvertoryObj = {
        mainDressCategoryId: this.materialId.id,
        mainDressCategoryColorId: this.colorId.mainDressCategoryColorId,
        ...filterObj,
      };
      await this.addInventoryProductSize({
        object: addInvertoryObj,
        successCallback: () => {
          this.inventoryProductSizeFromColorId(addInvertoryObj.mainDressCategoryColorId);
        },
      });
    },

    async matProps(mat) {
      // this.$emit('inside', mat)
      this.materialPropId = mat.materialId;
      this.classNameCh = mat.inventoryProductId;
      this.size = mat.size;
      this.artNum = mat.articleNumber;
      await this.productsByArticleNumber(mat.articleNumber);
    },
    async getMaterialVByMandP() {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Meter',
      });
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Part',
      });
    },
  },
};
</script>

<style lang="scss">

.team_table td {
  padding: 11px 6px !important;
}

.small:hover {
  border: 0.1px solid #FF274F !important;
  background: white;
  color: #FF274F;
  transition: ease-in-out 0.3s;
  width: 150px;
  height: 30px;
}

.modal-backdrop
{
    opacity:0.5 !important;
}
.modal-backdrop.show {
    opacity: 0.7;
}
.hover-row:hover {
    background-color: rgba(255, 39, 79, 0.1);
}
.products-listing__wrapper {
  .mats-listing {
    margin-top: 0;
  }
  .table__search-input {
    visibility: hidden;
  }
}
// .button {
//   margin-bottom: 0px !important;
//   width: 195.22px;
//   background: #FF274F !important;
//   color: #f4f1ed;
//   border-color: transparent;
// }

.mat {
  display: flex;
  justify-content: space-between;
  align-content: center;
  &.active {
    background-color: #e8e8e8;
  }
  div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  span {
    margin-left: 10px;
    svg {
      font-size: 15px;
    }
  }
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}



@media screen and (min-width: 1400px) and (max-width: 1500px) {
  .products-listing__wrapper {
    width: 100% !important;
  }
}
@media screen and (max-width: 1400px) {
  .products-listing__wrapper {
    width: 100% !important;
    margin-right: 5px;
    margin-left: 5px;
  }

  // }
  .products-listing__wrapper2 {
    width: 100% !important;
    margin-left: 5px;
    margin-right: 5px;

    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
  }
}

@media screen and (max-width: 1200px){
  .products-listing__wrapper{
    width: 100% !important;
    margin-right: 15px;
    margin-left: 0px;
  }
}

@media screen and (max-width: 1100px){
  .products-listing__wrapper{
    width: 100% !important;
    margin-right: 0px !important;
    margin-left: 0px;
  }
}

@media screen and (max-width: 896px) {
  .products-listing__wrapper {
    width: auto !important;
    flex-basis: 47%;
  }
}
</style>
